"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomOTPInput_1 = __importDefault(require("../../../components/otpInput/CustomOTPInput"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importDefault(require("../../../constants/constants"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const VerifyPhoneScreen = (props) => {
    const { confirm } = props.route.params;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [value, setValue] = (0, react_1.useState)("");
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    (0, react_1.useEffect)(() => {
        (async () => {
            const _phoneNumber = await AsyncStorage_1.default.get(constants_1.default.CHANGE_PHONE_NUMBER);
            if (!!_phoneNumber) {
                setPhoneNumber(_phoneNumber);
                await AsyncStorage_1.default.remove(constants_1.default.CHANGE_PHONE_NUMBER);
            }
        })();
        return () => {
            AsyncStorage_1.default.remove(constants_1.default.CHANGE_PHONE_NUMBER);
        };
    }, []);
    const handleConfirmCode = () => {
        if (!value)
            return;
        setLoading(true);
        confirm?.confirm(value)
            .then(async (response) => {
            const firebaseToken = await response.user?.getIdToken();
            if (firebaseToken) {
                User_1.default.authnSMS(firebaseToken)
                    .then((response) => {
                    dispatch((0, slice_2.updatePhoneNumberAction)(response.data.phone_number));
                    dispatch(slice_1.default.actions.showToast('電話番号を変更しました'));
                    (0, rootNavigation_1.navigate)(Routes_1.default.EDIT_PHONE_SUCCESS_SCREEN);
                })
                    .catch((error) => {
                    dispatch(slice_1.default.actions.setToastType(false));
                    if (typeof error?.response?.data?.error?.message === 'string') {
                        return dispatch(slice_1.default.actions.showToast(error?.response?.data?.error?.message));
                    }
                    dispatch(slice_1.default.actions.showToast('予期せぬエラーが発生しました。'));
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
        })
            .catch(error => {
            setLoading(false);
            switch (error.code) {
                case 'auth/invalid-verification-code':
                    setErrorMessage('認証コードが無効です。');
                    break;
                case 'auth/session-expired':
                    setErrorMessage('認証コードの有効期限が過ぎています。');
                default:
                    setErrorMessage(`予期せぬエラーが発生しました。\nCode: ${error?.code}`);
                    break;
            }
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                }, title: "電話番号変更", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "SMS\u8A8D\u8A3C")),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(12),
                            marginBottom: (0, scale_1.scale)(4),
                        } },
                        phoneNumber,
                        " \u5B9B\u3066\u306BSMS\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } }, "SMS\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u78BA\u8A8D\u30B3\u30FC\u30C96\u6841\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(react_native_1.View, { style: { alignItems: 'center', marginTop: (0, scale_1.scale)(24) } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainOtp },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                    fontSize: (0, scale_1.moderateScale)(14),
                                    lineHeight: (0, scale_1.moderateScale)(21),
                                    color: "#292A33",
                                } }, "\u78BA\u8A8D\u30B3\u30FC\u30C9"),
                            react_1.default.createElement(CustomOTPInput_1.default, { onCodeFilled: (value) => {
                                    setValue(value);
                                    setErrorMessage('');
                                }, errorMessage: errorMessage }),
                            react_1.default.createElement(react_native_1.TouchableOpacity, null,
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(14),
                                        lineHeight: (0, scale_1.moderateScale)(21),
                                        color: "#007AFF",
                                        marginTop: (0, scale_1.scale)(12),
                                    }, onPress: () => {
                                        (0, rootNavigation_1.navigate)(Routes_1.default.EDIT_PHONE_SCREEN);
                                    } }, "\u78BA\u8A8D\u30B3\u30FC\u30C9\u304C\u9001\u3089\u308C\u306A\u3044\u5834\u5408")))),
                    react_1.default.createElement(components_1.LinearButton, { title: "\u8A8D\u8A3C", onPress: handleConfirmCode, containerStyle: { marginTop: (0, scale_1.scale)(32) }, textStyle: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#FEFEFE'
                        }, style: {
                            width: '100%',
                            height: (0, scale_1.scale)(48),
                            borderRadius: (0, scale_1.scale)(4),
                        }, disabled: !value })))),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = VerifyPhoneScreen;
